import Vue from 'vue'

export default {
  info: params => {
    return Vue.http.get(Vue.prototype.serverUrl + 'pay/info', {
      params: params
    })
  },
  create: params => {
    return Vue.http.get(`${Vue.prototype.serverUrl}pay/create`, {
      params: params
    })
  }
}



// WEBPACK FOOTER //
// ./src/models/models/Pay.js